// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2mUev","loaderOuter":"PageOverlayLoader_loaderOuter__3ggOC"};